module.exports = __webpack_public_path__ + "img/mi-cuenta.55176e23.svg";